<template>
  <div class="event">
    <div class="pay">
      <Header :name="$t('payment.services.' + $route.params.payment)" :min="_.get(providerInfo, 'min_pay', '')" :max="_.get(providerInfo, 'max_pay', '')"/>
      <form class="app-pay-form" @submit.prevent="send" v-if="!is_sms">
        <slot name="content"></slot>
          <div class="col">
            <div class="inline-form">
              <label>Kart üzerindeki Ad Soyad</label>
              <input type="text" v-model="form.card_printed_name" placeholder="John Value" autocomplete="off">
            </div>
          </div>
          <div class="col">
            <div class="inline-form">
              <label>Kart Numaranız</label>
              <input :type="isMobile ? 'tel' : 'number'" v-model="form.cardnum" oninput="if(value.length>16)value=value.slice(0,16)"  placeholder="Kart numaranızı yazınız" autocomplete="off">
            </div>
          </div>
          <div class="col">
            <div class="inline-form">
              <label>S.K.T Ay</label>
              <select v-model="form.expire_month" oninput="if(value.length>2)value=value.slice(0,2)">
                  <option value="">Seçiniz</option>
                  <option  v-for="key in (_.range(1, 32) . map(num => ('0' + num).slice(-2)))" :key="key" :value="key">{{ key }}</option>
              </select>
            </div>
          </div>
          <div class="col">
            <div class="inline-form">
              <label>S.K.T Yıl</label>
              <select v-model="form.expire_year" oninput="if(value.length>4)value=value.slice(0,4)">
                  <option value="">Seçiniz</option>
                  <option  v-for="key in (_.range(current_year, (current_year + 20)))" :key="key" :value="key">{{ key }}</option>
              </select>
            </div>
          </div>
          <div class="col">
            <div class="inline-form">
              <label>CVV</label>
              <input :type="isMobile ? 'tel' : 'number'" v-model="form.cvv" oninput="if(value.length>3)value=value.slice(0,3)" id="card-cvv" placeholder="000" autocomplete="off">
            </div>
          </div>
          <div class="col">
            <div class="inline-form">
              <label>Tutar</label>
              <input :type="isMobile ? 'tel' : 'number'" placeholder="Yatırım tutarınızı yazınız" v-model="form.amount">
            </div>
          </div>
          <div class="col">
            <ButtonLoader class="primary block" :loader="btnLoading" :text="'Para Yatır'" />
          </div>
      </form>
      <form class="app-pay-form" @submit.prevent="sendSms" v-if="is_sms && _.isNull(is_response)">
          <div class="col">
            <div class="inline-form">
              <label>Sms Kodunuz</label>
              <input type="text" v-model="smsForm.code" placeholder="12345" autocomplete="off">
            </div>
          </div>
          <div class="col">
            <ButtonLoader class="primary block" :loader="smsBtnLoading" :text="'Para Yatır'" />
          </div>
      </form>
      <form class="app-pay-form" v-if="is_sms && is_response >= 0">
          <div class="transaction-status success" v-if="is_response == 1">
              <svg x="0px" y="0px" width="108px" height="63px" viewBox="0 0 108 63" enable-background="new 0 0 108 63" xml:space="preserve"> <path  d="M53.684,58.48H7.479c-1.058,0-1.916-0.857-1.916-1.915v-36.43h81.499v4.788c0,1.317,1.077,2.395,2.394,2.395 s2.395-1.078,2.395-2.395V7.667c0-3.691-3.013-6.704-6.703-6.704H7.479c-3.711,0-6.704,3.013-6.704,6.704v48.899 c0,3.69,3.013,6.703,6.704,6.703h46.226c1.316,0,2.394-1.077,2.394-2.394S55.021,58.48,53.684,58.48z M7.479,5.751h77.668 c1.057,0,1.915,0.858,1.915,1.916v7.681H5.543V7.667C5.543,6.609,6.421,5.751,7.479,5.751z"/> <path  d="M48.696,37.912c0-1.317-1.077-2.395-2.394-2.395H17.533c-1.316,0-2.394,1.077-2.394,2.395 c0,1.316,1.078,2.394,2.394,2.394h28.769C47.639,40.306,48.696,39.229,48.696,37.912z"/> <path  d="M17.533,44.096c-1.316,0-2.394,1.078-2.394,2.395s1.078,2.395,2.394,2.395h11.512 c1.317,0,2.394-1.078,2.394-2.395s-1.077-2.395-2.394-2.395H17.533z"/> <path  d="M17.254,31.627h28.769c1.317,0,2.394-1.077,2.394-2.394s-1.077-2.394-2.394-2.394H17.254 c-1.316,0-2.394,1.077-2.394,2.394S15.917,31.627,17.254,31.627z"/> <g> <g> <path  d="M81.986,59.973c-2.072,2.072-5.435,2.072-7.506,0L62.854,48.344c-2.072-2.07-2.072-5.433,0-7.504 c2.07-2.072,5.432-2.072,7.504,0l6.928,6.928c0.523,0.521,1.373,0.521,1.896,0L97.94,29.008c2.071-2.072,5.434-2.072,7.506,0 C106.44,30.003,107,31.354,107,32.76c0,1.407-0.56,2.758-1.554,3.752L81.986,59.973z"/> </g> </g> </svg>
              Ödemeniz başarılı bir şekilde tamamlandı !
          </div>
          <div class="transaction-status danger" v-if="is_response != 1 && !_.isNull(is_response)">
              <svg x="0px" y="0px" width="108px" height="63px" viewBox="0 0 108 63" enable-background="new 0 0 108 63" xml:space="preserve"> <path  d="M53.684,58.48H7.479c-1.058,0-1.916-0.857-1.916-1.915v-36.43h81.499v4.788c0,1.317,1.077,2.395,2.394,2.395 s2.395-1.078,2.395-2.395V7.667c0-3.691-3.013-6.704-6.703-6.704H7.479c-3.711,0-6.704,3.013-6.704,6.704v48.899 c0,3.69,3.013,6.703,6.704,6.703h46.226c1.316,0,2.394-1.077,2.394-2.394S55.021,58.48,53.684,58.48z M7.479,5.751h77.668 c1.057,0,1.915,0.858,1.915,1.916v7.681H5.543V7.667C5.543,6.609,6.421,5.751,7.479,5.751z"/> <path  d="M48.696,37.912c0-1.317-1.077-2.395-2.394-2.395H17.533c-1.316,0-2.394,1.077-2.394,2.395 c0,1.316,1.078,2.394,2.394,2.394h28.769C47.639,40.306,48.696,39.229,48.696,37.912z"/> <path  d="M17.533,44.096c-1.316,0-2.394,1.078-2.394,2.395s1.078,2.395,2.394,2.395h11.512 c1.317,0,2.394-1.078,2.394-2.395s-1.077-2.395-2.394-2.395H17.533z"/> <path  d="M17.254,31.627h28.769c1.317,0,2.394-1.077,2.394-2.394s-1.077-2.394-2.394-2.394H17.254 c-1.316,0-2.394,1.077-2.394,2.394S15.917,31.627,17.254,31.627z"/> <g> <path  d="M94.593,43.811l12.187-12.188c0.293-0.292,0.293-0.767,0-1.06l-4.501-4.503 c-0.142-0.141-0.333-0.22-0.53-0.22c-0.199,0-0.391,0.079-0.53,0.22L89.029,38.247L76.842,26.059c-0.28-0.281-0.777-0.281-1.06,0 l-4.503,4.503c-0.292,0.292-0.292,0.768,0,1.06l12.188,12.188L71.279,55.997c-0.292,0.293-0.292,0.767,0,1.059l4.503,4.505 c0.141,0.139,0.332,0.219,0.53,0.219c0.197,0,0.389-0.08,0.529-0.219l12.188-12.189l12.188,12.189 c0.14,0.139,0.331,0.219,0.53,0.219c0.197,0,0.389-0.08,0.53-0.219l4.501-4.505c0.294-0.292,0.294-0.767,0-1.059L94.593,43.811z"/> </g> </svg>
              Ödemeniz başarısız oldu lütfen tekrardan deneyiniz.
          </div>
      </form>
    </div>
  </div>
</template>

<script>
  import Header from '../../../../components/User/Pay/Header'
  import Form from '../../../../components/User/Pay/Form'

  export default{
    props: ['providerInfo'],
    data(){
      return{
        form: {
            cardnum: null,
            cvv: null,
            expire_date: null,
            amount: null,
            card_printed_name:null,
            card_type:'visa',
            expire_year: '',
            expire_month: '',
        },
        smsForm: {
            code : null,
            id: null,
        },
        loading: false,
        btnLoading: false,
        smsBtnLoading: false,
        is_response: null,
        is_sms: false,
      }
    },
    created(){
    },
    methods:{
      send(){
  		  this.btnLoading = true;
        axios.post('/user/wallet/deposit/greycard/create', this.form)
        .then((response) => {
          if (response.data.status) {
            this.$store.dispatch('alert/message', { type: 'success', msg: response.data.message })
            this.is_sms         = true;
            this.smsForm.id = response.data.id;
          };
        })
        .catch((err) => {
        })
        .finally(() => {
          this.btnLoading = false;
        });
      },
      sendSms(){
  		  this.smsBtnLoading = true;
        axios.post('/user/wallet/deposit/greycard/sms', this.smsForm)
        .then((response) => {
          if (response.data.status) {
            this.$store.dispatch('alert/message', { type: 'success', msg: response.data.message })
            this.is_response = response.data.result;
          };
        })
        .catch((err) => {
        })
        .finally(() => {
          this.smsBtnLoading = false;
        });
      }
    },
    computed: {
        current_year: function () {
            return parseInt(this.$moment().format('YYYY'));
        }
    },
    components:{
      Header,
      Form
    }
  }

</script>